import Slider from 'react-slick';

import SkillItem from './SkillItem';
import './SkillsSlider.css';

const PrevArrow = ({ currentSlide, slideCount, ...props }) => {
  return (
    <i
      {...props}
      className={'fas fa-chevron-left skills__slider__arrow-left'}
    ></i>
  );
};
const NextArrow = ({ currentSlide, slideCount, ...props }) => {
  return (
    <i
      {...props}
      className={'fas fa-chevron-right skills__slider__arrow-right'}
    ></i>
  );
};

const SkillsSlider = ({ data }) => {
  const settings = {
    prevArrow: <PrevArrow />,
    nextArrow: <NextArrow />,
    dots: true,
    infinite: false,
    speed: 500,
    slidesToShow: 5,
    slidesToScroll: 4,
    initialSlide: 0,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 4,
          slidesToScroll: 3,
          infinite: true,
          dots: true,
        },
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 2,
          initialSlide: 2,
          rows: 2,
        },
      },
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 2,
          initialSlide: 2,
          rows: 3,
        },
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
          rows: 2,
        },
      },
    ],
  };

  return (
    <div className="skills__slider">
      <Slider {...settings}>
        {data.map((each, key) => {
          return <SkillItem name={each.name} key={key} icon={each.icon} />;
        })}
      </Slider>
    </div>
  );
};

export default SkillsSlider;
